// extracted by mini-css-extract-plugin
export default {"file-type-container":"FileType_file-type-container__buF03"};